import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { nextGuideStep } from "@/lib/guide";

export function NextStepNudge() {
  const { user } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);

  const load = useCallback(() => {
    api.get("/onboarding/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
  }, [load, location.pathname]);

  useEffect(() => {
    const onRefresh = () => load();
    window.addEventListener("gx-guide-refresh", onRefresh);
    window.addEventListener("focus", onRefresh);
    return () => {
      window.removeEventListener("gx-guide-refresh", onRefresh);
      window.removeEventListener("focus", onRefresh);
    };
  }, [load]);

  if (!user || user.restricted) return null;
  if (!status?.tour_done) return null;

  const next = nextGuideStep(status);
  if (!next || location.pathname.startsWith(next.to)) return null;

  return (
    <div
      className="border-b border-primary/15 bg-primary/[0.04]"
      data-testid="next-step-nudge"
    >
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-6 py-2.5 lg:px-10">
        <Sparkles className="h-4 w-4 shrink-0 text-primary" />
        <p className="flex-1 text-sm text-foreground">
          <span className="font-semibold">Next:</span> {next.label}. {next.hint}
        </p>
        <Link
          to={next.to}
          className="inline-flex shrink-0 items-center gap-1 text-sm font-semibold text-primary hover:underline"
          data-testid="next-step-nudge-cta"
        >
          Let's go <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
}
